import CompanyManagementLayout from './CompanyManagementLayout';

export default CompanyManagementLayout;
